import PaymentConfigurationService from './paymentConfiguration.repo.js';
import FinalPaymentService from './finalPayment.repo.js';
import CustomerProtectionService from './customerprotection.repo.js';
import PermissionsService from './permissions.repo.js';
import DonationService from './donations.repo.js';
import HostedPaymentService from './hostedPayment.repo.js';
import QuickPayService from './quickpay.repo.js';
import PaymentPlanService from './paymentPlan.repo.js';
import Redirect from './redirect.repo.js';
import EventLog from './eventLog.repo.js';
import AuthenticationService from './authentication.repo';
import PostAdjustmentService from './postAdjustment.repo';
import PostChargeService from './postCharge.repo';

// Setup mutation error tracking
const debug = process.env.NODE_ENV !== 'production';

export default {
    AuthenticationService,
    PaymentConfigurationService,
    FinalPaymentService,
    CustomerProtectionService,
    PermissionsService,
    DonationService,
    HostedPaymentService,
    QuickPayService,
    PaymentPlanService,
    Redirect,
    EventLog,
    PostAdjustmentService,
    PostChargeService,
}